<script>
  import { Button } from 'sveltestrap';
  export let search, // algolia index search result
    page, // current page, bind:page in parent
    action;
  const handlePage = (n) => {
    console.log(`pager: page ${page} of ${search.nbPages}, adjusting by ${n}`);
    if ((n < 0 && page > 0) || (n > 0 && page < search.nbPages - 1)) {
      page += n;
      action();
    }
  };
</script>

<div>
  <br />
  {#if page > 0}<Button color="primary" on:click={() => handlePage(-1)}
      >Previous</Button
    >{/if}
  Page {page + 1} of {search.nbPages}
  {#if page < search.nbPages - 1}<Button
      color="primary"
      on:click={() => handlePage(1)}>Next</Button
    >{/if}
</div>
